import { useEffect, useState } from 'react';

// HORO-10509: no shared breakpoint hook existed anywhere in the codebase —
// Header.js's isDesktopViewport() and UserMenu.js's resize listener each
// re-implement their own one-off matchMedia/innerWidth check inline. This
// is the first reusable one, needed by both EntryStep and SetPasswordStep
// for the new desktop modal-card layout (mobile keeps its existing
// full-bleed view unchanged). 769px matches the existing
// `responsive-above(769px)` SCSS mixin convention (Modal, AnonHomePage)
// rather than the 768px some JS call sites use — chosen because this
// hook's counterpart is Modal's own bottom-sheet-vs-centered-card
// breakpoint, which the new desktop auth card deliberately mirrors.
const DESKTOP_QUERY = '(min-width: 769px)';

export const useIsDesktopViewport = () => {
    const [isDesktop, setIsDesktop] = useState(
        () => typeof window !== 'undefined' && Boolean(window.matchMedia) && window.matchMedia(DESKTOP_QUERY).matches
    );

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return undefined;
        }

        const mql = window.matchMedia(DESKTOP_QUERY);
        const onChange = (event) => setIsDesktop(event.matches);

        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, []);

    return isDesktop;
};
